module.exports = __webpack_public_path__ + "img/@team_img_01.6a46d421.jpg";